import React, { Component } from "react";
import UserImage from "../user_image";
import { Link } from "react-router-dom";
import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });
class UserRecommendationLine extends Component {
  state = {};
  render() {
    const style = { cursor: "pointer" };

    return (
      <div className="row max_height_55 user_recommendation_line">
        <div className="width_image_question">
          <UserImage user={this.props.recommendation.user} />
        </div>
        <div className="width_text_question">
          <label className="title" onClick={this.showFullPageComments}>
            {this.props.recommendation.user.first_name}{" "}
            {this.props.recommendation.user.last_name}
            {this.renderFeatured()}
          </label>
        </div>

        <div
          className="width_image_question hashtag_recommendation"
          onClick={this.showHashtagPage}
        >
          <Link
            style={style}
            to={"/hashtag/" + this.props.recommendation.hashtag}
          >
            <label>#{this.props.recommendation.hashtag}</label>
          </Link>
        </div>
      </div>
    );
  }

  renderFeatured() {
    if (this.props.featured === true) {
      if (this.props.question === true) {
        return (
          <span className="featured">
            {strings.yaystack_question_ask} [{strings.yaystack_selection}]
          </span>
        );
      }
      return <span className="featured">{strings.yaystack_selection}</span>;
    } else if (this.props.question === true) {
      return <span className="featured">{strings.yaystack_question_ask}</span>;
    }
    return "";
  }

  showFullPageComments = e => {
    this.props.showFullPageComments(this.props.recommendation);
  };

  showHashtagPage = e => {};
}

export default UserRecommendationLine;



// WEBPACK FOOTER //
// ./src/components/recommendation/user_recommendation_line.jsx